import React from 'react';
import I18n from 'i18n-js';
import classNames from 'classnames';

import { RCButton } from '@reverbdotcom/cadence/components';
import ModalDialog from '@reverbdotcom/commons/src/components/modal_dialog';

import TransactionsTableContainer from './TransactionsTableContainer';
import LiveListingsTableContainer from './LiveListingsTableContainer';

export const PAGE_SIZE = 10;
export const MAX_PAGES = 10;

interface IExternalProps {
  canonicalProductIds: string[];
}

export default function SellFormPricingGuidanceModal({
  canonicalProductIds,
}: IExternalProps) {
  const [isOpen, setIsOpen] = React.useState(false);
  const [isSoldListingsSelected, selectSoldListings] = React.useState(true);
  const isLiveListingsSelected = !isSoldListingsSelected;

  return (
    <div className="sell-form-pricing-guidance-modal">
      <RCButton onClick={() => setIsOpen(true)}>
        {I18n.t('discovery.sellForm.pricingSection.pricingGuidance.viewLiveAndSoldPrices')}
      </RCButton>
      <ModalDialog
        isOpen={isOpen}
        onRequestClose={() => setIsOpen(false)}
        onSubmit={() => setIsOpen(false) }
        headerTitle={I18n.t('discovery.sellForm.pricingSection.pricingTables.listings.header')}
        saveButtonText={I18n.t('discovery.sellForm.pricingSection.pricingTables.close')}
        hideFooterDismissButton
      >
        <div className="sell-form-pricing-guidance-modal__nav">
          <div className={classNames({
            'sell-form-pricing-guidance-modal__nav--selected': isSoldListingsSelected,
          })}>
            <RCButton
              onClick={() => selectSoldListings(true)}
            >
              {I18n.t('discovery.sellForm.pricingSection.pricingTables.listings.tabs.soldListingPrices')}
            </RCButton>
          </div>

          <div className={classNames({
            'sell-form-pricing-guidance-modal__nav--selected': isLiveListingsSelected,
          })}>
            <RCButton
              onClick={() => selectSoldListings(false)}
            >
              {I18n.t('discovery.sellForm.pricingSection.pricingTables.listings.tabs.liveListingPrices')}
            </RCButton>
          </div>
        </div>

        {isSoldListingsSelected ? (
          <TransactionsTableContainer
            canonicalProductIds={canonicalProductIds}
          />
        ) : (
          <LiveListingsTableContainer
            canonicalProductIds={canonicalProductIds}
          />
        )}

        <p className="mt-4 mb-0 color-secondary">
          {I18n.t('discovery.sellForm.pricingSection.pricingTables.disclaimer')}
        </p>
      </ModalDialog>
    </div>
  );
}
